import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment  from 'moment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-voucher-report-print',
  templateUrl: './voucher-report-print.component.html',
  styleUrls: ['./voucher-report-print.component.css']
})
export class VoucherReportPrintComponent implements OnInit {
  PaymentModelSearch = {
    AccountGroupID: '0',
    AccID: 0,
    FromDate:  moment(Date.now()).format("DD-MMM-YYYY"),
    ToDate:  moment(Date.now()).format("DD-MMM-YYYY"),
    Print:'',
    VoucherType:"",
    VoucherName:""
};
  constructor(private activatedRoute:ActivatedRoute,private accService:AccountingService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { 
    this.activatedRoute.queryParams.subscribe(params => {
     
      this.PaymentModelSearch.FromDate = params['FromDate'];
      this.PaymentModelSearch.ToDate = params['ToDate'];
      this.PaymentModelSearch.AccID = params['AccID'];
      this.PaymentModelSearch.VoucherName =decodeURIComponent(params['VoucherName']) ;
      this.PaymentModelSearch.VoucherType = params['VoucherType'];
      this.PaymentModelSearch.Print="P";
      this.GetVoucherReport();
  });
  }
  BranchDetails:any;
  loadingSearch = false;
  TotalDebit = 0;
  TotalCredit = 0;
VoucherReportList:any;
GetVoucherReport () {
    this.TotalDebit = 0;
    this.TotalCredit = 0;
    this.PaymentModelSearch.Print = "";
    if (this.PaymentModelSearch.VoucherType !="") {
        this.loadingSearch = true;
    this.spinnerService.show()
        this.accService.GetVoucherReport(JSON.stringify(this.PaymentModelSearch)).subscribe( (response)=> {
            this.VoucherReportList = response.VoucherReportList;
            this.BranchDetails=response.BranchDetails;
            if (this.VoucherReportList.length > 0) {
                this.TotalDebit = 0;
                this.TotalCredit = 0;
                for (var i = 0; i < this.VoucherReportList.length; i++) {
                    this.TotalDebit = this.TotalDebit + this.VoucherReportList[i].DebitAmt;
                    this.TotalCredit = this.TotalCredit + this.VoucherReportList[i].CreditAmt;

                }
            }
           setTimeout( () =>{
            this.spinnerService.hide()
            window.print();
                this.loadingSearch = false;                
            }, 100);
        });
    }
};
PrintDate:any;
ngOnInit() {
  this.PrintDate = new Date();
}
}
